import React from 'react';
import styles from '../en-us.module.css';

function EmersonHeader() {
    return (
        <div className="emerson-header">
            <div className={styles["cm-row"]}>
                <header className={[styles["global-header"], styles["navbar"], styles["navbar-fixed-top"]].join(' ')}>
                    <nav className={styles["utility-nav"]}>
                        <div className={[styles["hidden-xs"], styles["hidden-sm"]].join(' ')}>
                            <ul id="ul-horizontal-list" className={styles["horizontal-list"]}>
                                <li><a className="emerson-header" href="https://www.emerson.com/en-us/about-us">About</a></li>
                                <li><a className="emerson-header" href="https://www.emerson.com/en-us/investors">Investors</a></li>
                                <li><a className="emerson-header" href="https://www.emerson.com/en-us/careers">Careers</a></li>
                                <li><a className="emerson-header" href="https://www.emerson.com/en-us/contact-us">Contact Us</a></li>
                                <li><a className="emerson-header" href="https://www.emerson.com/en-us/news">News &amp; Events</a></li>
                                <li>&nbsp;&nbsp;</li>
                                <li>English</li>
                            </ul>
                        </div>
                    </nav>
                    <nav className={styles["main-header"]} style={{ justifyContent: 'center' }}>
                        <div className="main-header-content">
                            <div className={styles["navbar-header"]} id="cm-navigation">
                                <div className={[styles["navbar-brand"], styles["emerson-logo-box"]].join(' ')} style={{width: 0}}>
                                    <a href="https://www.emerson.com/en-us" title="" className={styles["emerson-logo__link"]}>
                                        <div className={styles["emerson-logo__image-box"]}>
                                            <img id="emersonlogo" className={styles["cm-image emerson-logo__image"]} src="images/emerson-logo-compressed--data-5576584.png" alt="Emerson Logo" title=""/>
                                        </div>
                                        <span className={styles["cm-visuallyhidden"]}></span>
                                    </a>
                                </div>
                            </div>
                            <div className="main-nav G001-main-nav" id="main-nav">
                                <div className="level-1-item-container">
                                    <a className="level-1-item" href="https://www.emerson.com/en-us/automation-solutions">AUTOMATION SOLUTIONS</a>
                                </div>
                                <div className="level-1-item-container">
                                    <a className="level-1-item" href="https://www.emerson.com/en-us/commercial-residential-solutions">COMMERCIAL & RESIDENTIAL SOLUTIONS</a>
                                </div>
                            </div>
                        </div>
                    </nav>
                </header>
            </div>
        </div>
    );
  }

export default EmersonHeader;